import { h } from "@stencil/core";
export class ExpandableList {
    onExpandableChanged(e) {
        if (e.detail && !this.multiple) {
            this.el.querySelectorAll('oebbx-expandable-item').forEach(item => {
                if (item !== e.target) {
                    item.close().then();
                }
            });
        }
    }
    render() {
        return (h("ul", { key: '4829340168fec239b178ae5bf95565cef8cc67b7', class: "expandable-list" }, h("slot", { key: 'ff3668bb86b7e903da597557c3fce4565afc931b' })));
    }
    static get is() { return "oebbx-expandable-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["expandable-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["expandable-list.css"]
        };
    }
    static get properties() {
        return {
            "multiple": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "multiple",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "expandableOpened",
                "method": "onExpandableChanged",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=expandable-list.js.map
